import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, SxProps, Typography} from '@mui/material';

import {bodyPdf} from '../styles';

import {DataComparisonBar} from '../../../../components/DataComparisonBar/DataComparisonBar';
import {EmpionPaper} from '../../../../components/EmpionPaper/EmpionPaper';
import {LanguageContext} from '../../../../contexts/LanguageContext/LanguageContext';
import {orangeColors} from '../../../../layouts/theme/designSystem';
import {CultureSatisfactionElement} from '../../culture/dashboard/types/CultureSatisfactionTypes';

interface CardData {
  key: string;
  title: {
    en: string;
    de: string;
  };
  data?: CultureSatisfactionElement;
}

interface Props {
  cardData: CardData[];
}

export const SatisfactionAnalysisCards = ({cardData}: Props) => {
  const {t} = useTranslation('pdfDomain');
  const currentLanguage = useContext(LanguageContext);

  const paperStyles: SxProps = {
    backgroundColor: orangeColors[5],
    width: '100%',
    boxShadow: 'none',
    padding: 3,
    borderRadius: 2,
    border: `1px solid ${orangeColors[3]}`,
    mb: 2,
  };

  return (
    <>
      {cardData.map(
        (item, index) =>
          item.data && (
            <EmpionPaper key={index} sx={paperStyles}>
              <Grid item container justifyContent={'space-between'}>
                <Grid item xs={8}>
                  <Typography sx={bodyPdf}>{item.title[currentLanguage]}</Typography>
                </Grid>
                <Grid item xs={8}>
                  <DataComparisonBar
                    indicators={[{value: item.data.average, color: orangeColors[100], height: '30px'}]}
                    bubbleAmount={6}
                  />
                  <Grid item container justifyContent={'space-between'} mt={3}>
                    <Grid item sm={6}>
                      <Typography sx={bodyPdf} textAlign={'left'}>
                        {t('satisfactionAnalysis.questionCards.labelLeft')}
                      </Typography>
                    </Grid>
                    <Grid item sm={6}>
                      <Typography sx={bodyPdf} textAlign={'right'}>
                        {t('satisfactionAnalysis.questionCards.labelRight')}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item textAlign={'start'} pl={2} xs={3}>
                  <Grid item textAlign={'start'}>
                    <Typography sx={{marginBottom: 1, ...bodyPdf}}>
                      &empty; {t('shared.employees')}: {item.data.average}
                    </Typography>
                  </Grid>
                  <Typography sx={{...bodyPdf}}>{t('satisfactionAnalysis.questionCards.lowestValue')}</Typography>
                  <Typography sx={{...bodyPdf}}>{t('satisfactionAnalysis.questionCards.highestValue')}</Typography>
                </Grid>
              </Grid>
            </EmpionPaper>
          )
      )}
    </>
  );
};
